//! TODO Deprecated - remove this component from app
import React from 'react'

import { CircularProgress } from '../CircularProgress'
import { CheckRegularIcon, XmarkRegularIcon } from '../svgIcons'
import type { ButtonProps } from './Button'
import { ButtonWithIcon } from './ButtonWithIcon'

const CLEAR_TIME = 1800 // in ms

interface ProgressButtonProps extends ButtonProps {
  loading: boolean
  succeed: boolean
  failed: boolean
}

// TODO make smoother state change (animation)
// TODO design fix? - do not change size when state changes
const ProgressButton = React.forwardRef<HTMLButtonElement, ProgressButtonProps>(
  ({ disabled, loading, succeed, failed, ...rest }, ref) => {
    const [icon, setIcon] = React.useState<NonNullable<React.ReactNode> | undefined>(undefined)
    const timerRef = React.useRef<number | undefined>(undefined)

    React.useEffect(() => {
      if (loading) {
        setIcon(<CircularProgress size={16} color="inherit" />)
      } else if (succeed) {
        setIcon(<CheckRegularIcon size={18} />)
        timerRef.current = window.setTimeout(() => setIcon(undefined), CLEAR_TIME)
      } else if (failed) {
        setIcon(<XmarkRegularIcon size={10} />)
        timerRef.current = window.setTimeout(() => setIcon(undefined), CLEAR_TIME)
      } else {
        setIcon(undefined)
      }

      return () => {
        if (timerRef.current) {
          clearTimeout(timerRef.current)
        }
      }
    }, [failed, loading, succeed])

    return <ButtonWithIcon ref={ref} icon={icon} disabled={disabled || loading} {...rest} />
  }
)

ProgressButton.displayName = 'ProgressButton'

export default ProgressButton
